export default "__VITE_ASSET__LCk_ClfB__"